(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["section"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    // Auto carousel functionality
    class SectionCarousel {
      constructor(element) {
        this.element = element;
        this.children = Array.from(element.children);
        this.currentIndex = 0;
        this.intervalId = null;

        console.log('SectionCarousel initialized with', this.children.length, 'children');

        // Check if we have children
        if (this.children.length === 0) {
          console.warn('No children found in carousel');
          return;
        }

        // Check if in Shopify editor
        this.isEditor = typeof window.Shopify !== 'undefined' && window.Shopify.designMode === true;

        // Get settings
        const autoplay = element.dataset.carouselAutoplay === 'true';
        const loop = element.dataset.carouselLoop === 'true';
        this.shouldLoop = loop;

        const styles = getComputedStyle(element);
        this.duration = parseFloat(styles.getPropertyValue('--carousel-duration')) || 3000;

        console.log('Carousel settings:', {
          autoplay,
          loop,
          duration: this.duration,
          isEditor: this.isEditor,
        });

        // Initialize
        this.init();

        // Start autoplay if enabled and not in editor
        if (autoplay && !this.isEditor) {
          console.log('Starting carousel autoplay');
          this.start();
        } else {
          console.log('Carousel not auto-starting', { autoplay, isEditor: this.isEditor });
        }
      }

      init() {
        // Hide all items except first
        this.children.forEach((child, index) => {
          if (index === 0) {
            child.classList.add('carousel-active');
          } else {
            child.classList.remove('carousel-active');
          }
        });
        console.log('Carousel initialized - first item active');
      }

      next() {
        const nextIndex = this.currentIndex + 1;

        // Check if we should loop
        if (nextIndex >= this.children.length) {
          if (this.shouldLoop) {
            console.log('Looping back to start');
            this.goTo(0);
          } else {
            console.log('Reached end, stopping');
            this.stop();
          }
          return;
        }

        this.goTo(nextIndex);
      }

      goTo(index) {
        console.log('Transitioning from', this.currentIndex, 'to', index);

        // Remove active from current
        this.children[this.currentIndex].classList.remove('carousel-active');

        // Add active to next
        this.children[index].classList.add('carousel-active');

        this.currentIndex = index;
      }

      start() {
        this.stop(); // Clear any existing interval
        this.intervalId = setInterval(() => {
          this.next();
        }, this.duration);
        console.log('Carousel started with interval:', this.intervalId);
      }

      stop() {
        if (this.intervalId) {
          clearInterval(this.intervalId);
          console.log('Carousel stopped');
          this.intervalId = null;
        }
      }
    }

    // Initialize all carousels
    function initCarousels() {
      console.log('Initializing carousels...');
      const carousels = document.querySelectorAll('[data-carousel="true"]');
      console.log('Found', carousels.length, 'carousel(s)');

      carousels.forEach((carousel, index) => {
        console.log('Initializing carousel', index);
        new SectionCarousel(carousel);
      });
    }

    // Run on DOMContentLoaded and immediately if already loaded
    if (document.readyState === 'loading') {
      console.log('Waiting for DOMContentLoaded...');
      document.addEventListener('DOMContentLoaded', initCarousels);
    } else {
      console.log('DOM already loaded, initializing immediately');
      initCarousels();
    }

    // Re-initialize when sections are edited in Shopify theme editor
    if (typeof window.Shopify !== 'undefined' && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', function () {
        console.log('Section reloaded in editor');
        initCarousels();
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
